import Navigation from "./modules/Navigation";
import Carousels from "./modules/Carousels";
import {YoutubeVideo, YouTubeEmbed} from "./modules/YoutubeVideo";
import WEBsellentModal from "./modules/WEBsellentModal";
import {WEBsellentAccordion} from "./modules/WEBsellentAccordion";
import {MegaMenu} from "./modules/MegaMenu";

new Navigation();
new Carousels();
YoutubeVideo();
YouTubeEmbed();
MegaMenu();
new WEBsellentModal('.openModal');
WEBsellentAccordion();